import EventHandler from 'bootstrap/js/src/dom/event-handler';

export const initiateWidgetComparison = widget => {
  if (!widget) return;

  const columns = widget.querySelectorAll('.column');
  if (!columns.length) return;

  function syncRowHeights() {
    const rowCount = Math.min(...Array.from(columns).map(c => c.children.length));

    for (let i = 0; i < rowCount; i++) {
      let maxHeight = 0;

      columns.forEach(col => {
        const cell = col.children[i];
        if (!cell) return;
        cell.style.height = 'auto';
        maxHeight = Math.max(maxHeight, cell.offsetHeight);
      });

      columns.forEach(col => {
        const cell = col.children[i];
        if (cell) cell.style.height = maxHeight + 'px';
      });
    }
  }

  syncRowHeights();

  let resizeTimer;
  window.addEventListener(
    'resize',
    () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncRowHeights, 150);
    },
    {passive: true}
  );

  window.addEventListener('load', syncRowHeights);

  columns.forEach(col => {
    col.addEventListener('mouseenter', () => col.classList.add('hovered'));
    col.addEventListener('mouseleave', () => col.classList.remove('hovered'));
  });

  const rowCount = Math.min(...Array.from(columns).map(c => c.children.length));
  for (let i = 0; i < rowCount; i++) {
    const rowCells = Array.from(columns, col => col.children[i]).filter(Boolean);

    rowCells.forEach(cell => {
      cell.addEventListener('mouseenter', () => {
        rowCells.forEach(c => c.classList.add('hovered'));
      });
      cell.addEventListener('mouseleave', () => {
        rowCells.forEach(c => c.classList.remove('hovered'));
      });
    });
  }

  const observer = new ResizeObserver(() => {
    requestAnimationFrame(syncRowHeights);
  });
  columns.forEach(col => observer.observe(col));

  EventHandler.on(document, 'shown.bs.tab', '[data-bs-toggle="tab"][data-product-id]', ({target}) => {
    const {productId: tabProductId} = target.dataset;
    columns.forEach(col => {
      col.classList.toggle('column-highlight', col.dataset.productId === tabProductId);
    });
  });
};
